import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DarkModeService {

  private darkModeSubject: BehaviorSubject<boolean>;
  darkModeChanged$: Observable<boolean>;

  constructor() {
    const isDarkModeEnabled = JSON.parse(localStorage.getItem('isDarkModeEnabled'));
    this.updateTheme(isDarkModeEnabled);
    this.darkModeSubject = new BehaviorSubject<boolean>(isDarkModeEnabled);
    this.darkModeChanged$ = this.darkModeSubject.asObservable();
  }

  // Toggle Dark Mode
  toggleDarkMode(): void {
    const isDarkModeEnabled = !this.darkModeSubject.value;
    this.updateTheme(isDarkModeEnabled);
    localStorage.setItem('isDarkModeEnabled', JSON.stringify(isDarkModeEnabled));
    this.darkModeSubject.next(isDarkModeEnabled);
  }

  // Is Dark Mode Enabled
  isDarkModeEnabled(): boolean {
    return this.darkModeSubject.value;
  }

  // Update Theme
  private updateTheme(isDarkModeEnabled: boolean): void {
    if (isDarkModeEnabled) {
      document.documentElement.setAttribute('data-bs-theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-bs-theme', 'light');
    }
  }
}
